import type {FlexSuiteHeroProps} from './types'
import {FlexSuiteHeroDefault} from './FlexSuiteHeroDefault'
import {FlexSuiteHeroStacked} from './FlexSuiteHeroStacked'
import {FlexSuiteHeroCarousel} from './FlexSuiteHeroCarousel'
import {FlexSuiteHeroIconCards} from './FlexSuiteHeroIconCards'
import {FlexSuiteHeroImageCards} from './FlexSuiteHeroImageCards'
import {FlexSuiteHero5050} from './FlexSuiteHero5050'

export function FlexSuiteHero(props: FlexSuiteHeroProps) {
  const {heroVariant} = props

  switch (heroVariant) {
    case 'Stacked':
      return <FlexSuiteHeroStacked fields={props} />
    case 'Carousel':
      return <FlexSuiteHeroCarousel fields={props} />
    case 'Icon Cards':
      return <FlexSuiteHeroIconCards fields={props} />
    case 'Image Cards':
      return <FlexSuiteHeroImageCards fields={props} />
    case '50/50':
      return <FlexSuiteHero5050 fields={props} />
    case 'Default':
    default:
      return <FlexSuiteHeroDefault fields={props} />
  }
}
